/** @format */

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { FormikProps } from 'formik';
import * as React from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectConstants } from './Api/constantSlice';
import { ErrorBox } from '../custom/ErrorBox';

interface Props {
  formik: FormikProps<any>;
  isDisabled: boolean;
}
export default function Race({ formik, isDisabled }: Props) {
  const selData = useAppSelector(selectConstants);
  const raceEnums = (race: string) => {
    switch (race) {
      case 'African':
        return 1;
      case 'White':
        return 2;
      case 'Indian':
        return 3;
      case 'Coloured':
        return 4;

      default:
        break;
    }
  };
  return (
    <>
      {selData.constantState.race && (
        <>
          <FormControl fullWidth>
            <InputLabel
              error={formik.touched.race && Boolean(formik.errors.race)}
              id='demo-select-small'>
              Race
            </InputLabel>
            <Select
              name='race'
              labelId='demo-select-small'
              id='demo-select-small'
              value={formik.values.race}
              label='Race'
              disabled={isDisabled}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={formik.touched.race && Boolean(formik.errors.race)}>
              <MenuItem value={0} disabled>
                Select Race
              </MenuItem>
              {selData.constantState.race.map((item: string, key: number) => {
                return (
                  <MenuItem key={key} value={raceEnums(item)}>
                    {item}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

           <ErrorBox>
           {formik.touched.race && (formik.errors.race as React.ReactNode)}
                              </ErrorBox>
          
          
        
        </>
      )}
    </>
  );
}
